module.exports = __webpack_public_path__ + "static/media/2.1d704792.jpg";